import { Selector } from '@ngxs/store';
import { OnboardingState } from './onboarding.state';
import { OnboardingStateModel } from './onboarding.model';

export class OnboardingSelectors {
  @Selector([OnboardingState])
  static step(state: OnboardingStateModel) {
    return state.step;
  }

  @Selector([OnboardingState])
  static graphic(state: OnboardingStateModel) {
    return state.graphic;
  }

  @Selector([OnboardingState])
  static signupID(state: OnboardingStateModel) {
    return state.registerDetails?.id;
  }

  @Selector([OnboardingState])
  static registerDetails(state: OnboardingStateModel) {
    return state.registerDetails;
  }

  @Selector([OnboardingState])
  static stepAndShowProgress(state: OnboardingStateModel) {
    return {
      step: state.step,
      showProgress: state.showProgress,
    };
  }

  @Selector([OnboardingState])
  static showProgress(state: OnboardingStateModel) {
    return state.showProgress;
  }

  @Selector([OnboardingState])
  static businessDetails(state: OnboardingStateModel) {
    return state.businessDetails;
  }
}
